let instanceCount = 0;

export const generateUniqueIds = (svg: SVGElement): SVGElement => {
	const identifiedElements = svg.querySelectorAll('[id]');

	if (identifiedElements.length === 0) {
		return svg;
	}

	const prefix = `uid-${++instanceCount}`;
	const renamedIds = new Map<string, string>();

	identifiedElements.forEach((element) => {
		renamedIds.set(element.id, `${prefix}-${element.id}`);
		element.id = `${prefix}-${element.id}`;
	});

	const urlReference = /url\(['"]?#([^'")]+)['"]?\)/g;

	// ponytail: only rewrites url(#id) references; href="#id" (<use>,
	// gradient inheritance) and <style> blocks inside icons are not
	// handled — add if an icon ever ships one
	[svg, ...svg.querySelectorAll('*')].forEach((element) => {
		[...element.attributes].forEach((attribute) => {
			const updatedValue = attribute.value.replace(
				urlReference,
				(match, id: string) => {
					const renamed = renamedIds.get(id);
					return renamed ? `url(#${renamed})` : match;
				},
			);

			if (updatedValue !== attribute.value) {
				attribute.value = updatedValue;
			}
		});
	});

	return svg;
};
